import React, { useEffect } from "react";
import { getStoreLink } from "../utils/chatPage";

// Reached only when the "Open" universal link did not open the app,
// i.e. IDless is not installed: send the user to the store.
const ImportUserFallbackPage: React.FC = () => {
  const storeLink = getStoreLink(navigator.userAgent);

  useEffect(() => {
    window.location.replace(storeLink);
  }, [storeLink]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f9f9f9",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          background: "#ffffff",
          borderRadius: 16,
          padding: "32px 24px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        <img
          src="/idlesslogo.png"
          alt="IDless Logo"
          style={{
            width: 64,
            height: 64,
            borderRadius: 12,
            objectFit: "cover",
            marginBottom: 20,
          }}
        />

        <h3 style={{ marginBottom: 8 }}>Get IDless</h3>
        <p style={{ color: "#777", fontSize: 14, marginBottom: 20 }}>
          Install the app, then tap Open App in your chat again.
        </p>

        <a
          href={storeLink}
          style={{
            display: "inline-block",
            padding: "10px 20px",
            borderRadius: 999,
            background: "#007bff",
            color: "#fff",
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Get the app
        </a>

        <div style={{ marginTop: 16 }}>
          <button
            type="button"
            onClick={() => window.history.back()}
            style={{
              border: "none",
              background: "none",
              color: "#007bff",
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            Back to chat
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportUserFallbackPage;
